<template>
  <div class="order-item-wrap mb16 dt-hand" @click="handleOrderCardClick">
    <div class="order-item-head">
      <div class="d-flex align-items-center justify-content-between">
        <div class="lh21 bold fs-14" v-if="sourcePage !== PageNames.HOME_PAGE">
          {{ getOrderType }}
        </div>
        <!-- use class 'bg-green' for delivered, 'bg-yellow' for being-baked, 'bg-blue' for advance order -->
        <div
          class="tag-order-type"
          v-if="sourcePage !== PageNames.HOME_PAGE"
          :class="getOrderStateBgClass"
        >
          {{ getOrderState }}
        </div>
      </div>
      <div class="d-flex align-items-center color-slaty">
        <div
          class="fs-12 mt2"
          v-if="sourcePage !== PageNames.HOME_PAGE && order?.store?.orderId"
        >
          Order #<span class="dt-link">{{ order?.store?.orderId }} </span>
        </div>
        <div class="fs-12 mt2" v-else>Order</div>
        <span class="color-x-grey-light plr4 fs-18"> | </span>
        <div class="fs-12 order-date mt2">
          {{ getDateInFormat() }}
        </div>
      </div>
    </div>
    <div class="order-item-content mt10">
      <div v-for="item in filterItems" :key="item?.itemId">
        <items-list :data-items="item" :data-price-card="false"></items-list>
      </div>
      <div
        class="more-items mb8"
        v-if="order?.items?.length > 3 && this.limit"
        @click.stop="showMore"
      >
        +{{ order?.items?.length - 3 }} <span>more</span>
      </div>
    </div>
    <!-- <div class="order-item-content mt10 border-bottom" v-else>
      <div v-for="item in order?.items" :key="item?.itemId">
        <items-list :data-items="item" :data-price-card="false"></items-list>
      </div>
      <div class="more-items mb8" v-if="order?.items?.length > 3">
        +{{ order?.items?.length - 3 }} <span>more</span>
      </div>
    </div> -->
    <div class="order-item-foot">
      <div class="d-flex align-items-center">
        <span class="fs-18 bold">
          <span class="rs">Rs.</span>{{ order?.netPrice }}
        </span>
        <span class="ver-seprator"></span>
        <span class="fs-11 color-slaty">{{ order?.items?.length }}</span>
        <span v-if="order?.items?.length > 1" class="color-slaty fs-11"
          >&nbsp;Items</span
        >
        <span v-else class="color-slaty fs-11">&nbsp;Item</span>
      </div>

      <div class="bold">
        <span
          class="btn small secondary"
          @click="trackAdvanceCtaHandler"
          v-if="
            order?.advanceOrder &&
            isOrderTrackable &&
            sourcePage != PageNames.HOME_PAGE
          "
          >Track</span
        >
        <span
          class="line-btn small"
          @click="reorderCtaHandler"
          v-else-if="!isOrderTrackable || sourcePage == PageNames.HOME_PAGE"
          >Reorder</span
        >
        <span
          class="btn small secondary"
          @click="trackCtaHandler"
          v-else-if="isOrderTrackable && sourcePage != PageNames.HOME_PAGE"
          >Track</span
        >
      </div>
    </div>
    <order-history-rating
      :data-order="order"
      v-if="showRating"
      :data-props="moduleProps"
      @click="gotoFeedback"
    ></order-history-rating>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import Utility from "../helpers/utility";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { OrderHistoryPages } from "../helpers/orderHistoryConstants";
import { OrderTypesFromCode } from "../helpers/orderTypesConstants";
import {
  EVENT_CLICK_REORDER,
  EVENT_CLICK_TRACKORDER,
  EVENT_CLICK_ORDER_DETAIL,
} from "../helpers/analyticsEvents";
import { keyMapsMutation, keyMapsAction } from "../helpers/storeKeys";
import PageNames from "../config/pageNames";
import OrderHistoryRating from "./OrderHistoryRating.vue";
import { OrderStatusCode } from "../helpers/OrderStatusConstants";

export default {
  name: "OrderItemCard",
  components: {
    ItemsList: defineAsyncComponent(() => import("./ItemsList.vue")),
    OrderHistoryRating,
  },
  props: {
    dataResults: { required: false, default: "" },
    sourcePage: { required: false, default: "" },
    activateOrderCardClick: { required: false, default: false },
    index: { required: false, default: 0 },
    dataProps: { required: true, default: {} },
  },
  data() {
    return {
      PageNames,
      order: {},
      limit: 3,
      ratingTags: {},
      moduleProps: {},
    };
  },
  mounted() {
    this.order = this.dataResults;
    this.moduleProps = this.dataProps;
  },
  methods: {
    getDateInFormat() {
      if (this.sourcePage == PageNames.HOME_PAGE) {
        return (
          Utility.getDateStringFromTimeStamp(this.order?.orderTimeStamp) +
          " " +
          Utility.getTimeFromTimeStamp(this.order?.orderTimeStamp)
        );
      }
      let res = this.order?.advanceOrder
        ? this.order?.advanceOrderTimeStamp > Date.now()
          ? "Estimated delivery by " +
            Utility.getDateStringFromTimeStamp(
              this.order?.advanceOrderTimeStamp,
            ) +
            " " +
            Utility.getAdvanceCardTimeStringFromTimeStamp(
              this.order?.advanceOrderTimeStamp,
            )
          : Utility.getDateStringFromTimeStamp(
              this.order?.advanceOrderTimeStamp,
            )
        : Utility.getDateStringFromTimeStamp(this.order?.orderTimeStamp) +
          " " +
          Utility.getTimeFromTimeStamp(this.order?.orderTimeStamp);

      return res.replace(",", "");
    },
    reorderCtaHandler(event) {
      event.cancelBubble = true;
      event.preventDefault();
      EVENT_CLICK_REORDER({
        sectionPosition: this.index + 1,
        orderType: this.getOrderType,
        orderStatus: this.getOrderState,
        orderNumber: this.order?.orderId,
        orderDate: this.getOrderDate,
        productName: this.getOrderItemName,
        productPrice: this.getOrderItemPrice,
      });
      this.addToCartOnReorder(this.order?.id);
      Utility.sendToCartScreen();
    },
    addToCartOnReorder(item = "") {
      // let reorderedItems = LocalStorageFunc.getReorderedItems();
      // reorderedItems = [...reorderedItems, ...items];
      LocalStorageFunc.setReorderedItems(item);
    },
    trackCtaHandler(event) {
      event.cancelBubble = true;
      this.$store.commit(keyMapsMutation.UPDATE_ORDER_ID, this.order?.id);
      event.preventDefault();
      EVENT_CLICK_TRACKORDER({
        sectionPosition: this.index + 1,
        orderType: this.getOrderType,
        orderStatus: this.getOrderState,
        orderNumber: this.order?.orderId,
        orderDate: this.getOrderDate,
        productName: this.getOrderItemName,
        productPrice: this.getOrderItemPrice,
      });
      LocalStorageFunc.setOrderSummary(this.order);
      // Utility.sendToOrderTracking();
      this.dispatchTrackOrder();
    },
    dispatchTrackOrder() {
      this.$store.dispatch(keyMapsAction.GET_TRACK_ORDER_API, {
        mobile:
          this.order?.deliveryPhoneNumber || LocalStorageFunc.getMobileNumber(),
        order: this.order?.store?.orderId,
      });
    },
    handleOrderCardClick(event) {
      let { status } = Utility.getOrderState(this.order);
      this.$store.commit(keyMapsMutation.UPDATE_ORDER_ID, this.order?.id);
      event.preventDefault();
      if (this.activateOrderCardClick) {
        EVENT_CLICK_ORDER_DETAIL({
          sectionPosition: this.index + 1,
          sectionName: this.getOrderType,
          paymentMethod: this.getPaymentMethods,
          orderDate: this.getOrderDate,
          productName: this.getOrderItemName,
          productPrice: this.getOrderItemPrice,
          orderNumber: this.order?.orderId,
          discountAmount: this.order?.discount,
          subTotal: this.order?.netPrice,
          itemTotal: this.order?.price,
          tax: this.order?.tax,
          popeyesWalleFlag: 0,
          popeyesWalletAmount: 0,
        });
        LocalStorageFunc.setOrderSummary(this.order);
        if (
          this.order?.currentOrder ||
          (this.order?.advanceOrder && this.order?.advanceOrderInProgress)
        ) {
          switch (status) {
            case "PENDING":
              {
                // @todo implement proper condition for track order
                // redirects to track order detail page
                // Utility.sendToOrderTracking();
                this.dispatchTrackOrder();
              }
              break;
            case "FAILED": {
              LocalStorageFunc.setOrderHistoryPage(
                OrderHistoryPages.PREVIOUS_ORDERS_DETAIL,
              );
              Utility.sendToOrderHistory();
            }
            case "CANCELLED":
              LocalStorageFunc.setOrderHistoryPage(
                OrderHistoryPages.PREVIOUS_ORDERS_DETAIL,
              );
              Utility.sendToOrderHistory();
            case "SUCCESS":
              {
                // redirects to previous order detail page
                LocalStorageFunc.setOrderHistoryPage(
                  OrderHistoryPages.PREVIOUS_ORDERS_DETAIL,
                );
                Utility.sendToOrderHistory();
              }
              break;
            default:
              {
                if (status <= 4) {
                  // @todo implement proper condition for track order
                  // redirects to track order detail page
                  // Utility.sendToOrderTracking();
                  this.dispatchTrackOrder();
                } else if (status == 5 || status == 9) {
                  // redirects to previous order detail page
                  LocalStorageFunc.setOrderHistoryPage(
                    OrderHistoryPages.PREVIOUS_ORDERS_DETAIL,
                  );
                  Utility.sendToOrderHistory();
                } else if (status == 10) {
                  // redirects to advanced order detail page
                  LocalStorageFunc.setOrderHistoryPage(
                    OrderHistoryPages.ADVANCED_ORDER_DETAIL,
                  );
                  Utility.sendToOrderHistory();
                } else {
                  // @todo implement proper condition for track order
                  // redirects to track order detail page
                  // Utility.sendToOrderTracking();
                  this.dispatchTrackOrder();
                }
              }
              break;
          }
        } else {
          LocalStorageFunc.setOrderHistoryPage(
            OrderHistoryPages.PREVIOUS_ORDERS_DETAIL,
          );
          Utility.sendToOrderHistory();
        }
      }
    },
    trackAdvanceCtaHandler(event) {
      event.cancelBubble = true;
      this.$store.commit(keyMapsMutation.UPDATE_ORDER_ID, this.order?.id);
      event.preventDefault();
      EVENT_CLICK_TRACKORDER({
        sectionPosition: this.index + 1,
        orderType: this.getOrderType,
        orderStatus: this.getOrderState,
        orderNumber: this.order?.orderId,
        orderDate: this.getOrderDate,
        productName: this.getOrderItemName,
        productPrice: this.getOrderItemPrice,
      });
      LocalStorageFunc.setOrderHistoryPage(
        OrderHistoryPages.ADVANCED_ORDER_DETAIL,
      );
      LocalStorageFunc.setOrderSummary(this.order);
      Utility.sendToOrderHistory();
    },
    showMore() {
      this.limit = 0;
    },
    gotoFeedback(event) {
      if (
        !this.order.foodRatingProvided ||
        !this.order.deliveryRatingProvided
      ) {
        event.cancelBubble = true;
        event.preventDefault();
        Utility.sendToCSATScreen(this.order?.id);
      }
    },
  },
  computed: {
    getOrderType() {
      return (
        OrderTypesFromCode[this.order?.deliveryType] ||
        OrderTypesFromCode[this.order?.deliveryOrderType?.deliveryTypeCode] ||
        OrderTypesFromCode.DINEIN
      );
    },
    getPaymentMethods() {
      const keys = Object.keys(this.order?.paymentResponse);
      return this.order?.paymentResponse[keys[0]]?.paymentType;
    },
    getOrderItemName() {
      return this.order?.items?.map((item) => item.product.name).join(",");
    },
    getOrderItemPrice() {
      return this.order?.items?.map((item) => item.pricePerQty).join(",");
    },
    getOrderDate() {
      return Utility.getDateNumberFromTimeStamp(this.order?.orderTimeStamp);
    },
    getOrderState() {
      let orderStatus = Utility.getOrderState(this.order);
      return orderStatus?.displayText || "Being Prepared";
    },
    isOrderTrackable() {
      return (
        this.order?.currentOrder ||
        (this.order?.advanceOrder && this.order?.advanceOrderInProgress)
      );
    },
    getOrderStateBgClass() {
      let orderStatus = Utility.getOrderState(this.order);
      return orderStatus?.displayBgClass || "bg-yellow";
    },
    filterItems() {
      return this.limit
        ? this.order?.items?.slice(0, this.limit)
        : this.order?.items;
    },
    showRating() {
      return OrderStatusCode[this.order?.deliveryOrderType?.deliveryTypeCode]
        ? OrderStatusCode[
            this.order?.deliveryOrderType?.deliveryTypeCode
          ][9].toLowerCase() == this.getOrderState.toLowerCase()
        : false;
    },
  },
};
</script>
